module.exports = __webpack_public_path__ + "static/media/events.d08c6ab2.svg";